<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer015">
<div class="_idGenObjectLayout-1">
<div class="hexagram" id="_idContainer007">
<img alt="hexagram ornament" class="_idGenObjectAttribute-1" src="image/Unicursal_Hexagram.png"/>
</div>
</div>
<p class="_tx_ded">Do what thou wilt shall be the whole of the Law.</p>
<p class="_tx_ded">—Aleister Crowley</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epi.vue?3d602133